export default "__VITE_PUBLIC_ASSET__38d0f9c4__"